
import styled from 'styled-components';


export const LastSectionDescription = styled.p`
  margin-top: 20px;
`;